module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_flower-16476bcc97e766313cbb5d3b6d7286c8.jpg";